<script>
    export default {
      components: {},
      props: {
        title: {
          type: String,
          default: '',
        },
      },
    }
    </script>
    
    <template>
      <!-- start page title -->
      <div class="row mt-3">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h5 class="mb-0" style="font-weight:bolder;">{{ title }}</h5>
          </div>
        </div>
      </div>
      <!-- end page title -->
    </template>
    